import RosterDetail from './RosterDetail';

export default RosterDetail;
